import React from 'react';

function AddVehicleContentWrapper({ children }) {
  return <div className="add-vehicle-content-wrapper">{children}</div>;
}

export default AddVehicleContentWrapper;
